export default __webpack_public_path__ + "static/media/fedex-logo.fa21b167.png";